import { FC, ReactElement } from 'react';
import Stack from '@mui/material/Stack';

// Assets
import { ReactComponent as IconWarning } from 'Components/ds/assets/icon-warning.svg';

// Components
import MapleContainer from 'Components/ds/MapleContainer';
import MapleCard from 'Components/ds/MapleCard';
import MapleCardHeader from 'Components/ds/MapleCardHeader';
import MapleCardContent from 'Components/ds/MapleCardContent';
import Typography from 'Components/ds/Typography';
import Icon3D from 'Components/ds/Icon3D';
import MapleLink from 'Components/ds/MapleLink';

const UnsupportedWallet: FC = (): ReactElement => {
  return (
    <MapleContainer maxWidth='medium' sx={{ my: 8 }}>
      <MapleCard>
        <MapleCardHeader title={`You have connected to Maple with a Safe via Wallet Connect.`} />
        <MapleCardContent>
          <Stack alignItems='center' spacing={2}>
            <Icon3D
              variant='error'
              icon={
                <Icon3D icon={<IconWarning />} variant='error' size='xSmall' borderintensity={500} shape='triangle' />
              }
            />
          </Stack>
          <Stack sx={{ pt: 2 }} spacing={1.2}>
            <Typography>{`For a better and more reliable experience using Maple, please connect to Maple inside of the Safe web interface. This can be done in one of two ways:`}</Typography>
            <Typography>Firstly, navigate to your Safe interface and go to: </Typography>
            <Typography weight='bold'>{`"Apps" -> "My custom apps" -> "Add custom Safe App"`}</Typography>{' '}
            <Typography>
              and enter <MapleLink href='https://app.maple.finance/'>https://app.maple.finance/</MapleLink> into the
              Safe App URL field. This will allow you to access Maple directly in your Safe.
            </Typography>
            <Typography>
              If you've previously added Maple as a Safe App, within the Safe web interface please go to:
            </Typography>
            <Typography weight='bold'>{`"Apps" -> "My custom apps" -> click on the Maple Finance application.`}</Typography>{' '}
            <Typography>This will open Maple inside of the Safe.</Typography>
          </Stack>
        </MapleCardContent>
      </MapleCard>
    </MapleContainer>
  );
};

export default UnsupportedWallet;
